import * as React from 'react';
import { Box, Button, Typography, Grid, Paper, Link } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import HelpIcon from '@mui/icons-material/Help';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import LikeDislike from './LikeDislike.tsx';

interface LandingPageProps {
  onGetStarted: () => void;
}

const LandingPage: React.FC<LandingPageProps> = ({ onGetStarted }) => {
  return (
    <Box
      sx={{
        marginTop: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 2,
      }}
    >
      <Typography component="h1" variant="h4" gutterBottom>
        Welcome to Fitbot
      </Typography>
      <Typography component="p" variant="body1" sx={{ mt: 2, mb: 4 }}>
      FitBot is your personal assistant for all your health and fitness needs. Interact with it to get the best experience.
      </Typography>
      
      <Grid container spacing={3} sx={{ mb: 4, maxWidth: '800px' }}>
        <Grid item xs={12} sm={6}>
          <Paper elevation={3} sx={{ padding: 2, textAlign: 'center', maxWidth: '350px', margin: '0 auto', height: '180px' }}>
            <ChatIcon fontSize="large" color="primary" />
            <Typography variant="h6" sx={{ mt: 2 }}>
              Chat with bot
            </Typography>
            <Typography variant="body2">
              Get instant help and support from the chatbot.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Paper elevation={3} sx={{ padding: 2, textAlign: 'center', maxWidth: '350px', margin: '0 auto', height: '180px' }}>
            <HelpIcon fontSize="large" color="secondary" />
            <Typography variant="h6" sx={{ mt: 2 }}>
              FAQs
            </Typography>
            <Typography variant="body2">
              Find answers to the most frequently asked questions.
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      <Button
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
        onClick={onGetStarted}
      >
        Get Started
      </Button>

      <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', gap: 2 }}>
        <Link href="https://www.linkedin.com/in/abdullahtariq78/" target="_blank" rel="noopener">
          <LinkedInIcon fontSize="large" color="primary" />
        </Link>
        <Link href="https://github.com/Abdullahprogramme" target="_blank" rel="noopener">
          <GitHubIcon fontSize="large" color="action" />
        </Link>
      </Box>

      <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
        <LikeDislike />
      </Box>
      
    </Box>
  );
};

export default LandingPage;
